import type { Annotation } from "building-types/annotation/annotationTypes";
import type { RoomParameterValues } from "building-types/systemParameterTypes";
import type { Table } from "common/data/table";
import { titleOrSentenceCaseToCamelCase } from "common/utils/strings";
import { PlacementXAnchor, TextAlignment } from "common/utils/textAlignment";
import { parameterTokenNew } from "doc/parameterTools";
import { noteNew } from "doc/utils/annotation";
import { makeBuiltInLabelTable } from "doc/utils/labelTools";

function roomParameterValue(paramId: keyof RoomParameterValues): string {
  return parameterTokenNew(paramId);
}

export function makeRoomTagAnnotationGenerator(name: string, parameters: (keyof RoomParameterValues)[]) {
  const text = parameters.map((parameter) => roomParameterValue(parameter)).join("\n");
  return (): Table<Annotation> => {
    const note = noteNew({
      text,
      name,
      id: titleOrSentenceCaseToCamelCase(name),
      x: 0,
      y: 0,
      sortIndex: 0,
      textAlignment: TextAlignment.CENTER,
      placementXAnchor: PlacementXAnchor.CENTER,
      labels: makeBuiltInLabelTable("addToFloorPlan", "addToBrochurePlan", "addToShowroomPlan"),
    });

    return {
      [note.id]: note,
    };
  };
}

export const generateDefaultRoomTag = makeRoomTagAnnotationGenerator("Room Tag (Default)", [
  "roomReportedName",
  "roomTagDetails",
]);

export const generateCeilingHeightRoomTag = makeRoomTagAnnotationGenerator("Room Tag with Ceiling Height", [
  "roomReportedName",
  "roomCeilingHeight",
  "roomTagDetails",
]);

export const generateFloorMaterialRoomTag = makeRoomTagAnnotationGenerator("Room Tag with Floor Material", [
  "roomReportedName",
  "roomFloorMaterial",
  "roomTagDetails",
]);

export const generateDimensionsRoomTag = makeRoomTagAnnotationGenerator("Room Tag with Dimensions", [
  "roomReportedName",
  "roomDimensions",
  "roomTagDetails",
]);

export const generateAreaRoomTag = makeRoomTagAnnotationGenerator("Room Tag with Area", [
  "roomReportedName",
  "roomArea",
  "roomTagDetails",
]);
